import { render, staticRenderFns } from "./PackageCard.vue?vue&type=template&id=346930d0&"
import script from "./PackageCard.vue?vue&type=script&lang=js&"
export * from "./PackageCard.vue?vue&type=script&lang=js&"
import style0 from "./PackageCard.vue?vue&type=style&index=0&id=346930d0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports